import { collabStateManager } from '@databases/collab-state-manager';
import { useMemo } from 'react';
import { useSnapshot } from 'valtio';

import { currentHostFrameContext } from '@canvas/canvas-state/host-api';

import { getMediaClient, type MediaClient } from './media-client-core.ts';

export function useMediaClient(contentId: string | undefined): MediaClient | undefined {
  const collabManager = collabStateManager.getCollabManager(contentId ?? '');
  const frameContext = useSnapshot(currentHostFrameContext);
  const enforceDataSecurityPolicy =
    frameContext.data.dataSecurityPolicy?.attachmentDownload !== true;

  return useMemo(() => {
    if (collabManager) {
      return getMediaClient(collabManager, enforceDataSecurityPolicy);
    } else {
      return undefined;
    }
  }, [collabManager, enforceDataSecurityPolicy]);
}
